/** Contratos entre o Master e as instâncias dos provedores. */
export const INSTANCE_STATUSES = [
  'pending',
  'provisioning',
  'online',
  'degraded',
  'offline',
  'maintenance',
] as const;
export type InstanceStatus = (typeof INSTANCE_STATUSES)[number];

export const INSTANCE_STATUS_LABELS: Record<InstanceStatus, string> = {
  pending: 'Aguardando implantação',
  provisioning: 'Provisionando',
  online: 'Online',
  degraded: 'Degradada',
  offline: 'Offline',
  maintenance: 'Em manutenção',
};

/** Serviços que podem ser reiniciados pelo painel. Lista fechada — nada além disso. */
export const RESTARTABLE_SERVICES = ['api', 'web', 'caddy'] as const;
export type RestartableService = (typeof RESTARTABLE_SERVICES)[number];

export const INSTANCE_OPERATIONS = [
  'restart_service',
  'run_backup',
  'verify_backup',
  'apply_release',
  'collect_diagnostics',
  'set_ai_credentials',
  'set_erp_credentials',
  'test_erp_connection',
] as const;
export type InstanceOperation = (typeof INSTANCE_OPERATIONS)[number];

export const INSTANCE_OPERATION_LABELS: Record<InstanceOperation, string> = {
  restart_service: 'Reiniciar serviço',
  run_backup: 'Executar backup',
  verify_backup: 'Testar restauração do backup',
  apply_release: 'Aplicar versão',
  collect_diagnostics: 'Coletar diagnóstico',
  set_ai_credentials: 'Atualizar credencial de IA',
  set_erp_credentials: 'Atualizar credenciais do ERP',
  test_erp_connection: 'Testar integração com o ERP',
};

export const PROVISIONING_STEPS = [
  { key: 'register_provider', label: 'Cadastrar o provedor' },
  { key: 'register_vps', label: 'Registrar VPS e domínio' },
  { key: 'validate_access', label: 'Validar acesso seguro ao servidor' },
  { key: 'install_app', label: 'Instalar a aplicação' },
  { key: 'configure_db', label: 'Configurar banco de dados' },
  { key: 'configure_https', label: 'Configurar HTTPS' },
  { key: 'generate_credentials', label: 'Gerar credenciais exclusivas' },
  { key: 'security_checks', label: 'Executar verificações de segurança' },
  { key: 'create_admin', label: 'Criar usuário administrador do provedor' },
  { key: 'validate_deploy', label: 'Validar a implantação' },
] as const;
export type ProvisioningStepKey = (typeof PROVISIONING_STEPS)[number]['key'];

/** Verificações reportadas pelo agente; cada uma conclui uma etapa do provisionamento. */
export const INSTANCE_CHECKS = [
  { key: 'agentConnected', step: 'validate_access', label: 'Agente autenticado no Master' },
  { key: 'apiHealthy', step: 'install_app', label: 'Aplicação respondendo' },
  { key: 'database', step: 'configure_db', label: 'Banco de dados acessível e migrado' },
  { key: 'https', step: 'configure_https', label: 'Certificado HTTPS válido' },
  { key: 'secrets', step: 'generate_credentials', label: 'Credenciais exclusivas geradas' },
  { key: 'internalPortsClosed', step: 'security_checks', label: 'Banco e Redis sem portas públicas' },
  { key: 'adminUserExists', step: 'create_admin', label: 'Administrador do provedor criado' },
] as const;
export type InstanceCheckKey = (typeof INSTANCE_CHECKS)[number]['key'];

/** Serviços do docker-compose da instância (nomes usados pelo agente). */
export const INSTANCE_SERVICES = ['caddy', 'web', 'api', 'postgres', 'redis', 'agent'] as const;
